import { UserImage } from "@circleco/ui-kit";
import { useWatch } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { dateStringToTimeAgo } from "@/react/helpers/dateTimeHelpers/timeAgo";
import type { CommunityMember } from "@/react/types/CommunityMember";
import { Form } from "@circle-react-uikit/Form";
import { Typography } from "@circle-react-uikit/Typography";

interface ConnectModalContentProps {
  recipient: CommunityMember;
}

const i18nBase = "settings.connect.connect_modal";

export const ConnectModalContent = ({
  recipient,
}: ConnectModalContentProps) => {
  const noteValue = useWatch<{ note: string }>({ name: "note" }) ?? "";
  const characterCount = noteValue.length;

  return (
    <div className="space-y-6">
      <div className="bg-secondary flex items-center gap-3 rounded-xl px-4 py-3">
        <div className="flex size-10 items-center justify-center rounded-full">
          <UserImage
            isFullRounded
            name={recipient.name ?? ""}
            src={recipient.avatar_url}
            size="10"
          />
        </div>
        <div className="flex flex-col gap-[0.5]">
          <Typography.LabelSm weight="medium" color="text-primary">
            {recipient.name}
          </Typography.LabelSm>
          <Typography.BodyXs color="text-secondary">
            {recipient.headline ? `${recipient.headline} • ` : ""}
            {recipient.profile_confirmed_at
              ? t([i18nBase, "joined"], {
                  date: dateStringToTimeAgo(recipient.profile_confirmed_at),
                })
              : ""}
          </Typography.BodyXs>
        </div>
      </div>

      <div className="">
        <div>
          <Typography.LabelMd color="text-primary" weight="semibold">
            {t([i18nBase, "add_note"])}
          </Typography.LabelMd>
          <Typography.BodySm color="text-secondary">
            {t([i18nBase, "add_note_description"])}
          </Typography.BodySm>
        </div>

        <Form.Item
          name="note"
          className="!pt-3"
          hideLabel
          hideDescription
          hideBorder
          placeholder={t([i18nBase, "add_note_placeholder"])}
        >
          <Form.TextArea name="note" rows={3} maxLength={300} />
        </Form.Item>

        <div className="flex justify-end pt-1">
          <Typography.BodyXs color="text-secondary">
            {t([i18nBase, "add_note_max_length"], {
              character_count: characterCount,
            })}
          </Typography.BodyXs>
        </div>
      </div>
    </div>
  );
};
